import script from "./GeneralCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralCarousel.vue?vue&type=script&setup=true&lang=js"

import "./GeneralCarousel.vue?vue&type=style&index=0&id=64fcd094&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Vizion\\transfer-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fcd094"]])

export default __exports__